import React from 'react'
import { components } from 'react-select'

import { ReactComponent as ArrowIcon } from '../assets/select_arrow.svg'
import * as S from '../styles'

import type { DropdownIndicatorComponentProps } from './types'
import type { ReactElement } from 'react'

export const DropdownIndicator = <T,>(
  props: DropdownIndicatorComponentProps<T>
): ReactElement => {
  const {
    selectProps: { menuIsOpen, isDisabled, hasDropdown = true },
  } = props
  return !hasDropdown ? null : (
    <components.DropdownIndicator {...props}>
      <S.DropdownIndicatorContainer isOpen={menuIsOpen} isDisabled={isDisabled}>
        <ArrowIcon />
      </S.DropdownIndicatorContainer>
    </components.DropdownIndicator>
  )
}
